import { paystackImg } from "@/assets";
import { PostRequest } from "@/lib/http";
import { useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useSelector } from "react-redux";

const Paystack = () => {
  const [amount, setAmount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const user = useSelector((state) => state.user.user);

  async function initializeTransaction(e) {
    e.preventDefault();

    const fData = new FormData();
    fData.append("amount", amount);

    const { err, data } = await PostRequest({
      url: "/api/paystack-init",
      body: fData,
      setState: setIsLoading,
    });
    if (!err) {
      window.open(data.url, "_self");
    } else {
      setError(err);
    }
  }

  return (
    <div className="dark:bg-darkInput rounded-[20px] bg-white p-4 shadow">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src={paystackImg}
            alt="paystack logo"
            className="size-10 rounded-full"
          />

          <h2 className="text-lg font-bold">Paystack</h2>
        </div>
      </div>

      <div className="py-3 text-sm opacity-80">
        Deposit funds into your wallet using Paystack. Choose from multiple
        payment methods including card and bank transfer for convenient
        transactions
      </div>

      <form onSubmit={initializeTransaction} className="flex flex-col gap-2">
        <div className="dark:border-darkBorder dark:bg-darkInput flex items-center gap-x-3 rounded-xl border bg-gray-50 p-2 py-2.5">
          <CurrencyInput
            name="amount"
            placeholder="Input amount (₦)"
            value={amount}
            onValueChange={(e) => setAmount(e)}
            className="w-full border-none bg-transparent text-sm outline-none dark:text-white"
            required
            prefix="₦ "
          />
        </div>

        {error && (
          <span className="py-2 text-sm font-medium text-red-500 md:text-xs">
            {error}
          </span>
        )}

        <button
          className={`bg-primary focus:bg-primary w-full rounded-xl py-3 font-semibold text-white disabled:opacity-65`}
          disabled={isLoading}
        >
          {isLoading ? "Processing..." : "Continue"}
        </button>
      </form>
    </div>
  );
};

export default Paystack;
